import React from 'react';

function Header() {
  return (
    <header style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
      <video
        src="./video.mp4"
        autoPlay
        loop
        muted
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          padding: '20px',
        }}
      >
        <h1 style={{ fontSize: '3rem', fontWeight: 'bold', maxWidth: '800px', marginBottom: '1rem', paddingTop: '70px' }}>
          Bringing Comfort Home – Essential Lifestyle Services, Delivered
        </h1>

        <section style={{ maxWidth: '900px', marginTop: '2rem' }}>
          <h2 style={{ fontSize: '32px', fontWeight: 'bold', marginBottom: '1rem' }}>
            Why Choose RAS BSNS INC.
          </h2>

          <div style={{ marginBottom: '1.5rem' }}>
            <h4 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '0.5rem' }}>
              Fast & Reliable Service
            </h4>
            <p style={{ fontSize: '16px', fontWeight: '300' }}>
              From fragrances to kitchen essentials and clothing, we deliver convenience with speed and care.
            </p>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <h4 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '0.5rem' }}>
              Curated Essentials
            </h4>
            <p style={{ fontSize: '16px', fontWeight: '300' }}>
              We specialize in providing quality lifestyle services for everyday needs—fragrance selections, common kitchen setups, and wardrobe basics.
            </p>
          </div>

          <div>
            <h4 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '0.5rem' }}>
              Exceptional Customer Support
            </h4>
            <p style={{ fontSize: '16px', fontWeight: '300' }}>
              Our team is here to assist you—before, during, and after every service experience.
            </p>
          </div>
        </section>
      </div>
    </header>
  );
}

export default Header;
